import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, OnChanges, Output, HostListener, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faPlus, faTrash, faTimes, faGripVertical, faEdit, faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Subscription, interval } from 'rxjs';
import { takeWhile, tap, finalize } from 'rxjs/operators';
import { AutomationProcedimentService } from 'src/app/services/automation-procediment.service';

@Component({
  selector: 'app-automation-services-modal',
  templateUrl: './automation-services-modal.component.html',
  styleUrls: ['./automation-services-modal.component.sass']
})
export class AutomationServiceModalComponent implements OnInit,  OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Input() companyCnpj = '';
  @Output() closeModal = new EventEmitter<void>();
  
  faPlus = faPlus;
  faTrash = faTrash;
  faTimes = faTimes;
  faGripVertical = faGripVertical;
  faEdit = faEdit;
  faCheck = faCheck;
  faExclamationTriangle = faExclamationTriangle;
  
  loading = false;
  publishLoading = false;
  showCloseConfirmation = false;
  isAutomationModalVisible = false;
  uploading = false;
  uploadProgress = 0;
  fileName = '';
  apiMessage = '';
  apiErrors: Array<{ code?: string; line?: number; description?: string }> = [];
  successMessage = '';
  errorOccurred = false;
  private uploadSub: Subscription | null = null;
  private fileToUpload: File | null = null;
  constructor(
    private automationService: AutomationProcedimentService
  ) {}

  ngOnInit(): void { }
  ngOnChanges(): void { }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.clearMessages();
    if (!input.files || input.files.length === 0) {
      this.fileToUpload = null;
      this.fileName = '';
      return;
    }
    this.fileToUpload = input.files[0];
    this.fileName = this.fileToUpload.name;
  }
    startUpload(): void {
    if (!this.fileToUpload) return;

    this.clearMessages();
    this.uploading = true;
    this.uploadProgress = 0;

    this.loading = true;

    this.uploadSub = this.automationService.insertServices(this.fileToUpload, this.companyCnpj)
      .subscribe({
        next: (event: HttpEvent<any>) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.uploadProgress = Math.round((100 * event.loaded) / event.total);
          } else if (event.type === HttpEventType.Response) {
            const body = event.body;
            this.uploading = false;
            this.uploadProgress = 100;
            this.loading = false;

            if (body && body.status === 'FAILED') {
              this.errorOccurred = true;
              this.apiMessage = body.message || 'Erro ao processar arquivo';
              this.apiErrors = Array.isArray(body.errors) ? body.errors : [];
            } else {
              this.successMessage = (body && body.message) ? body.message : 'Upload concluído com sucesso';
              this.fileToUpload = null;
              this.fileName = '';
            }

            if (this.uploadSub) {
              this.uploadSub.unsubscribe();
              this.uploadSub = null;
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.uploading = false;
          this.uploadProgress = 0;
          this.loading = false;
          this.errorOccurred = true;

          const body = err.error;
          if (body && typeof body === 'object' && (body.status === 'FAILED' || body.errors)) {
            this.apiMessage = body.message || 'Erro na API';
            this.apiErrors = Array.isArray(body.errors) ? body.errors : [];
          } else {
            this.apiMessage = err.message || 'Erro inesperado ao enviar arquivo';
            this.apiErrors = [];
          }

          if (this.uploadSub) {
            this.uploadSub.unsubscribe();
            this.uploadSub = null;
          }
        }
      });
  }

  clearMessages(): void {
    this.apiMessage = '';
    this.apiErrors = [];
    this.successMessage = '';
    this.errorOccurred = false;
  }

  ngOnDestroy(): void {
    if (this.uploadSub) {
      this.uploadSub.unsubscribe();
    }
  }

  close(): void {
    this.clearMessages();
    this.closeModal.emit();
    this.isOpen = false;
  }
}